import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { View } from 'react-native'
import Txt from '../Txt'
import Menu from '../Menu'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import { getDateFormat, getTextCapitalized, getCardsLocationText, getRecurringTractorActiveDays } from '../../tools/dataParse'
import { usePlatforms } from '../../hooks/usePlatforms'
import Identity from '../../utils/Identity'
import LocationsIonformation from './LocationsInformation'
import useStyles from './useStyles'

const RecurringCard = ({ item, editTractor, deleteTractor }) => {
  const { isTablet, isDesktop } = usePlatforms()
  const { origin, destination, start_date, end_date, contact_name, contact_phone } = item
  const { theme } = useTheme()
  const styles = useStyles(theme, isTablet, isDesktop)

  const onEditTractor = useCallback(() => editTractor(item), [editTractor, item])
  const onDeleteTractor = useCallback(() => deleteTractor(item), [deleteTractor, item])

  const days = useMemo(() => getRecurringTractorActiveDays(item), [item])

  const menuItems = [
    {
      text: 'Edit',
      fn: onEditTractor
    },
    {
      text: 'Delete',
      fn: onDeleteTractor
    }
  ]

  return (
    <View
      style={[styles.cardStyle, Identity.Shadow(theme).Card, { flexDirection: 'column' }]}
    >
      <View style={{ width: '100%', flexDirection: 'row', alignItems: 'center' }}>
        <View style={{ flex: 1, flexDirection: isTablet ? 'row' : 'column' }}>
          <View style={{ flex: isTablet ? 3 : 1, flexDirection: 'row' }}>
            <LocationsIonformation
              origin={getCardsLocationText(origin)}
              destination={getCardsLocationText(destination)}
              style={{ flex: isTablet ? 2 : 1 }}
            />
            <View
              style={{
                flex: 1,
                alignItems: isDesktop ? 'center' : isTablet ? 'flex-start' : 'flex-end',
                justifyContent: isDesktop ? 'space-around' : 'space-between',
                flexDirection: isDesktop ? 'row' : 'column',
                borderRightWidth: isDesktop ? 1 : 0,
                borderLeftWidth: isDesktop ? 1 : 0,
                borderColor: theme.GEYSER,
                paddingLeft: 10
              }}
            >
              <View style={{ flex: 1, alignItems: isTablet ? 'flex-start' : 'flex-end' }}>
                <Txt
                  color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
                  text={getDateFormat(start_date)}
                  identity={isTablet ? 'body2' : 'body2Bold'}
                />
                <Txt
                  color='SLATE_GRAY'
                  text='Star date'
                  identity='body3'
                />
              </View>
              <View style={{ flex: 1, alignItems: isTablet ? 'flex-start' : 'flex-end' }}>
                <Txt
                  color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
                  text={getDateFormat(end_date)}
                  identity={isTablet ? 'body2' : 'body2Bold'}
                />
                <Txt
                  color='SLATE_GRAY'
                  text='End date'
                  identity='body3'
                />
              </View>
            </View>
          </View>
          <View
            style={{
              flex: 1,
              flexDirection: isDesktop ? 'row' : isTablet ? 'column' : 'row',
              justifyContent: isDesktop ? 'space-around' : 'space-between',
              alignItems: 'center',
              paddingLeft: 10
            }}
          >
            <View style={{ flex: 1 }}>
              <Txt
                text={contact_name}
                identity={isTablet ? 'body2' : 'body2Bold'}
                color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
              />
              <Txt
                text='Contact name'
                identity='body3'
                color='SLATE_GRAY'
                numberOfLines={1}
              />
            </View>
            <View style={{ flex: 1, alignItems: isTablet ? 'flex-start' : 'flex-end' }}>
              <Txt
                text={contact_phone}
                identity={isTablet ? 'body2' : 'body2Bold'}
                color={isTablet ? 'OUTER_SPACE' : 'SLATE_GRAY_TEXT'}
              />
              <Txt
                text='phone'
                identity='body3'
                color='SLATE_GRAY'
                numberOfLines={1}
              />
            </View>
          </View>
        </View>
        <Menu
          items={menuItems} style={styles.menuOptions}
        >
          <Icon
            fill={theme.SLATE_GRAY_TEXT}
            name='ShowMore'
            height={isDesktop ? 20 : 18}
            width={isDesktop ? 20 : 18}
          />
        </Menu>

      </View>
      {Boolean(days && days.length) && (
        <View
          style={{ marginTop: 20, width: '100%', flexDirection: 'row', flexWrap: 'wrap' }}
        >
          {days.map((day, index) => (
            <View
              key={index}
              style={styles.chips}
            >
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                <Txt
                  text={getTextCapitalized(day.slice(0, 3))}
                  identity='body3'
                  color='LOCHMARA'
                />
                <Txt
                  text={item[`tractors_available_${day.toLowerCase()}`]}
                  identity='body3'
                  color='LOCHMARA'
                />
              </View>
            </View>
          )
          )}

        </View>)}
    </View>
  )
}

RecurringCard.propTypes = {
  item: PropTypes.object.isRequired,
  editTractor: PropTypes.func,
  deleteTractor: PropTypes.func
}

function areEqual (prevProps, nextProps) {
  return false
}

export default React.memo(RecurringCard, areEqual)
